import { api } from './api';

export interface TeamSummary {
  id: string;
  name: string;
  managerId: string | null;
  manager: { id: string; firstName: string; lastName: string; email: string } | null;
  _count: { members: number; prospects: number };
  createdAt: string;
  updatedAt: string;
}

export const teamsApi = {
  list: (token: string) => api.get<TeamSummary[]>('/api/v1/teams', { accessToken: token }),
  get: (token: string, id: string) =>
    api.get<TeamSummary>(`/api/v1/teams/${id}`, { accessToken: token }),
  create: (token: string, body: { name: string }) =>
    api.post<TeamSummary>('/api/v1/teams', body, { accessToken: token }),
  update: (token: string, id: string, body: { name?: string; managerId?: string | null }) =>
    api.patch<TeamSummary>(`/api/v1/teams/${id}`, body, { accessToken: token }),
  delete: (token: string, id: string) =>
    api.delete<void>(`/api/v1/teams/${id}`, { accessToken: token }),
};
